import { NUMBER } from "../../constants/app-constants";

export default (details = {}) => {
    const {
        brand = {},
        model = {}
    } = details || {};
    const detailList = [brand, model];
    let progressIndex = NUMBER.ZERO;
    detailList.forEach(({id = null}) => {
        if (id || id === NUMBER.ZERO) {
            progressIndex++;
        }
    });
    return {
        isVisible: progressIndex === detailList.length,
        progressIndex
    };
};
